class AdderModel {
  id = null;
  constructor(adderData) {
    let { id } = adderData;
    this.id = id;
  }
}

export default AdderModel;
